<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import AddCommentForm from '@/components/CampaignParticipants/CampaignParticipantDetails/components/AddCommentForm.vue'
import DetailsActivity from '@/components/CampaignParticipants/CampaignParticipantDetails/components/DetailsActivity.vue'
import DetailsComment from '@/components/CampaignParticipants/CampaignParticipantDetails/components/DetailsComment.vue'
import type { User } from '@/types'
import type { AvatarDataType, CampaignParticipantDetailsType } from '@/types/campaignParticipant.types'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent/TypographyComponent.vue'

defineProps<{ participant: CampaignParticipantDetailsType }>()
const emit = defineEmits(['onDelete', 'onCommentAdd'])
const store = useStore()
const activitiesContainer = ref<HTMLElement>()
const user = computed<User>(() => store.getters['user/user'])

const containerHeight = computed(() => {
  if (activitiesContainer.value) {
    const { y } = activitiesContainer.value.getBoundingClientRect()
    return `${window.innerHeight - y - 24}px`
  }
  return 'auto'
})

const currentAuthorAvatarData = computed<AvatarDataType>(() => ({
  abbreviation: (user.value.first_name && user.value.surname
    ? user.value.first_name.charAt(0) + user.value.surname.charAt(0)
    : user.value.username.charAt(0)
  ).toUpperCase(),
  color: '#afecc4',
}))
</script>
<template>
  <BoxComponent :mb="16">
    <FlexComponent>
      <TypographyComponent variant="headline-small">Updates</TypographyComponent>
    </FlexComponent>
  </BoxComponent>
  <div v-if="participant" ref="activitiesContainer" :style="{ height: containerHeight }" class="participant-details-activity-container">
    <FlexComponent direction="column" :gap="16">
      <AddCommentForm
        :campaign-id="participant.offer_id"
        :participant-id="participant.id"
        :avatar-data="currentAuthorAvatarData"
        :on-comment-add="() => emit('onCommentAdd')"
      />
      <template v-if="participant.activity">
        <div v-for="(activity, index) in participant.activity" :key="activity.created_at">
          <!-- @vue-expect-error todo fix me-->
          <DetailsComment
            v-if="activity.type === 'COMMENT'"
            :campaign-id="participant.offer_id"
            :participant-id="participant.id"
            :comment="activity"
            :avatar-data="'avatar'"
            :is-author="user.id === activity.actor_id"
            :index="index"
            :on-delete="() => emit('onDelete')"
          />
          <!-- @vue-expect-error todo fix me-->
          <DetailsActivity v-else :activity="activity" :participant="participant" :index="index" />
        </div>
      </template>
    </FlexComponent>
  </div>
</template>
<style lang="scss" scoped>
.participant-details-activity-container {
  overflow: auto;
  padding: 0 24px;
  margin: 0 -24px;
}
</style>
